import { render, staticRenderFns } from "./SeveritySetup.vue?vue&type=template&id=2cb54e78&scoped=true&"
import script from "./SeveritySetup.vue?vue&type=script&lang=ts&"
export * from "./SeveritySetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb54e78",
  null
  
)

export default component.exports